import { z } from 'zod'

export const CurrencySchema = z
  .number()
  .min(1, { message: 'amount_is_required' })